import http from '../services/axios'

import {
  GET_HTTP_CONFIG,
  GET_BACKEND_URL,
  LOADING_PRISTINE,
  LOADING_STARTED,
  LOADING_COMPLETED_SUCCESS,
  LOADING_COMPLETED_FAILURE,
  SET_STUDY_RESULTS,
  SET_STUDY_RESULTS_AGE_STATE,
  SET_STUDY_RESULTS_GENDER_STATE,
  SET_STUDY_RESULTS_PRELIM_STATE,
  SET_STUDY_RESULTS_2_MARKET_SEGMENT_STATE,
  SET_STUDY_RESULTS_3_MARKET_SEGMENT_STATE,
  SET_STUDY_RESULTS_OVERALL_WORDS,
  SET_STUDY_RESULTS_AGE_WORDS_STATE,
  SET_STUDY_RESULTS_GENDER_WORDS_STATE,
  SET_STUDY_RESULTS_PRELIM_WORDS_STATE,
  SET_STUDY_RESULTS_2_MARKET_SEGMENT_WORDS_STATE,
  SET_STUDY_RESULTS_3_MARKET_SEGMENT_WORDS_STATE,
  SET_ALL_SECONDARY_STUDY_RESULTS_STATE,
  LOAD_ALL_STUDY_RESULTS_DATA,
  LOAD_STUDY_RESULTS,
  LOAD_STUDY_RESULTS_AGE,
  LOAD_STUDY_RESULTS_GENDER,
  LOAD_STUDY_RESULTS_PRELIM,
  LOAD_STUDY_RESULTS_2_MARKET_SEGMENT,
  LOAD_STUDY_RESULTS_3_MARKET_SEGMENT,
  LOAD_STUDY_RESULTS_OVERALL_WORDS,
  LOAD_STUDY_RESULTS_AGE_WORDS_STATE,
  LOAD_STUDY_RESULTS_GENDER_WORDS_STATE,
  LOAD_STUDY_RESULTS_PRELIM_WORDS_STATE,
  LOAD_STUDY_RESULTS_2_MARKET_SEGMENT_WORDS_STATE,
  LOAD_STUDY_RESULTS_3_MARKET_SEGMENT_WORDS_STATE,
  A_STORE_RESULTS_MODULE_PER_ROUTE_ACTIONS,
  R_NAME_RESULTS,
  GET_STUDY,
  GET_CURRENT_ROUTE, R_NAME_MANAGE_PARTICIPANTS, R_NAME_PURCHASE,
} from '../services/constants'

const module = {
  state: {
    studyResultsState: {
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    studyResultsOverallWordsState: {
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    studyResultsAgeState: { // http://api.bigmind.sifradigital.net:8080/api/results/segmented/641?type=age
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    studyResultsAgeWordsState: { // http://api.bigmind.sifradigital.net:8080/api/seg-words/641?type=age
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    studyResultsGenderState: { // http://api.bigmind.sifradigital.net:8080/api/results/segmented/641?type=gender
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    studyResultsGenderWordsState: { // http://api.bigmind.sifradigital.net:8080/api/seg-words/641?type=gender
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    studyResultsPrelimState: { // http://api.bigmind.sifradigital.net:8080/api/results/segmented/641?type=prelim-answer
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    studyResultsPrelimWordsState: { // http://api.bigmind.sifradigital.net:8080/api/seg-words/641?type=prelim-answer
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    studyResults2MarketSegmentsState: { // http://api.bigmind.sifradigital.net:8080/api/results/segmented/641?type=cluster
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    studyResults2MarketSegmentsWordsState: { // http://api.bigmind.sifradigital.net:8080/api/seg-words/641?type=cluster
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    studyResults3MarketSegmentsState: { // http://api.bigmind.sifradigital.net:8080/api/results/segmented/641?type=cluster2
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    studyResults3MarketSegmentsWordsState: { // http://api.bigmind.sifradigital.net:8080/api/seg-words/641?type=cluster2
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    allSecondaryStudyResultsState: {
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
  },
  mutations: {
    [SET_STUDY_RESULTS](state, payload) {
      state.studyResultsState = payload
    },
    [SET_STUDY_RESULTS_AGE_STATE](state, payload) {
      state.studyResultsAgeState = payload
    },
    [SET_STUDY_RESULTS_GENDER_STATE](state, payload) {
      state.studyResultsGenderState = payload
    },
    [SET_STUDY_RESULTS_PRELIM_STATE](state, payload) {
      state.studyResultsPrelimState = payload
    },
    [SET_STUDY_RESULTS_2_MARKET_SEGMENT_STATE](state, payload) {
      state.studyResults2MarketSegmentsState = payload
    },
    [SET_STUDY_RESULTS_3_MARKET_SEGMENT_STATE](state, payload) {
      state.studyResults3MarketSegmentsState = payload
    },
    [SET_STUDY_RESULTS_OVERALL_WORDS](state, payload) {
      state.studyResultsOverallWordsState = payload
    },
    [SET_STUDY_RESULTS_AGE_WORDS_STATE](state, payload) {
      state.studyResultsAgeWordsState = payload
    },
    [SET_STUDY_RESULTS_GENDER_WORDS_STATE](state, payload) {
      state.studyResultsGenderWordsState = payload
    },
    [SET_STUDY_RESULTS_PRELIM_WORDS_STATE](state, payload) {
      state.studyResultsPrelimWordsState = payload
    },
    [SET_STUDY_RESULTS_2_MARKET_SEGMENT_WORDS_STATE](state, payload) {
      state.studyResults2MarketSegmentsWordsState = payload
    },
    [SET_STUDY_RESULTS_3_MARKET_SEGMENT_WORDS_STATE](state, payload) {
      state.studyResults3MarketSegmentsWordsState = payload
    },
    [SET_ALL_SECONDARY_STUDY_RESULTS_STATE](state, payload) {
      state.allSecondaryStudyResultsState = payload
    },
  },
  actions: {
    [LOAD_STUDY_RESULTS]: (context) => {
      context.commit(SET_STUDY_RESULTS, {
        loadingState: LOADING_STARTED,
        data: context.state.studyResultsState.data,
        error: context.state.studyResultsState.error,
      })
      const studyId = context.getters[GET_CURRENT_ROUTE].params.id
      return http.get(
        context.getters[GET_BACKEND_URL](`results/combined/${studyId}`),
        context.getters[GET_HTTP_CONFIG]
      ).then(response => {
        context.commit(SET_STUDY_RESULTS, {
          loadingState: LOADING_COMPLETED_SUCCESS,
          data: response.data,
          error: null,
        })
      }).catch(err => {
        console.error(err)
        context.commit(SET_STUDY_RESULTS, {
          loadingState: LOADING_COMPLETED_FAILURE,
          data: null,
          error: err,
        })
      })
    },
    [LOAD_STUDY_RESULTS_AGE]: (context) => {
      context.commit(SET_STUDY_RESULTS_AGE_STATE, {
        loadingState: LOADING_STARTED,
        data: context.state.studyResultsAgeState.data,
        error: context.state.studyResultsAgeState.error,
      })
      const studyId = context.getters[GET_CURRENT_ROUTE].params.id
      return http.get(
        context.getters[GET_BACKEND_URL](`results/segmented/${studyId}?type=age`),
        context.getters[GET_HTTP_CONFIG]
      ).then(response => {
        context.commit(SET_STUDY_RESULTS_AGE_STATE, {
          loadingState: LOADING_COMPLETED_SUCCESS,
          data: response.data,
          error: null,
        })
      }).catch(err => {
        console.error(err)
        context.commit(SET_STUDY_RESULTS_AGE_STATE, {
          loadingState: LOADING_COMPLETED_FAILURE,
          data: null,
          error: err,
        })
      })
    },
    [LOAD_STUDY_RESULTS_GENDER]: (context) => {
      context.commit(SET_STUDY_RESULTS_GENDER_STATE, {
        loadingState: LOADING_STARTED,
        data: context.state.studyResultsGenderState.data,
        error: context.state.studyResultsGenderState.error,
      })
      const studyId = context.getters[GET_CURRENT_ROUTE].params.id
      return http.get(
        context.getters[GET_BACKEND_URL](`results/segmented/${studyId}?type=gender`),
        context.getters[GET_HTTP_CONFIG]
      ).then(response => {
        context.commit(SET_STUDY_RESULTS_GENDER_STATE, {
          loadingState: LOADING_COMPLETED_SUCCESS,
          data: response.data,
          error: null,
        })

      }).catch(err => {
        console.error(err)
        context.commit(SET_STUDY_RESULTS_GENDER_STATE, {
          loadingState: LOADING_COMPLETED_FAILURE,
          data: null,
          error: err,
        })
      })
    },
    [LOAD_STUDY_RESULTS_PRELIM]: (context) => {
      context.commit(SET_STUDY_RESULTS_PRELIM_STATE, {
        loadingState: LOADING_STARTED,
        data: context.state.studyResultsPrelimState.data,
        error: context.state.studyResultsPrelimState.error,
      })
      const studyId = context.getters[GET_CURRENT_ROUTE].params.id
      return http.get(
        context.getters[GET_BACKEND_URL](`results/segmented/${studyId}?type=prelim-answer`),
        context.getters[GET_HTTP_CONFIG]
      ).then(response => {
        context.commit(SET_STUDY_RESULTS_PRELIM_STATE, {
          loadingState: LOADING_COMPLETED_SUCCESS,
          data: response.data,
          error: null,
        })

      }).catch(err => {
        console.error(err)
        context.commit(SET_STUDY_RESULTS_PRELIM_STATE, {
          loadingState: LOADING_COMPLETED_FAILURE,
          data: null,
          error: err,
        })
      })
    },
    [LOAD_STUDY_RESULTS_2_MARKET_SEGMENT]: (context) => {
      context.commit(SET_STUDY_RESULTS_2_MARKET_SEGMENT_STATE, {
        loadingState: LOADING_STARTED,
        data: context.state.studyResults2MarketSegmentsState.data,
        error: context.state.studyResults2MarketSegmentsState.error,
      })
      const studyId = context.getters[GET_CURRENT_ROUTE].params.id
      return http.get(
        context.getters[GET_BACKEND_URL](`results/segmented/${studyId}?type=cluster2`),
        context.getters[GET_HTTP_CONFIG]
      ).then(response => {
        context.commit(SET_STUDY_RESULTS_2_MARKET_SEGMENT_STATE, {
          loadingState: LOADING_COMPLETED_SUCCESS,
          data: response.data,
          error: null,
        })

      }).catch(err => {
        console.error(err)
        context.commit(SET_STUDY_RESULTS_2_MARKET_SEGMENT_STATE, {
          loadingState: LOADING_COMPLETED_FAILURE,
          data: null,
          error: err,
        })
      })
    },
    [LOAD_STUDY_RESULTS_3_MARKET_SEGMENT]: (context) => {
      context.commit(SET_STUDY_RESULTS_3_MARKET_SEGMENT_STATE, {
        loadingState: LOADING_STARTED,
        data: context.state.studyResults3MarketSegmentsState.data,
        error: context.state.studyResults3MarketSegmentsState.error,
      })
      const studyId = context.getters[GET_CURRENT_ROUTE].params.id
      return http.get(
        context.getters[GET_BACKEND_URL](`results/segmented/${studyId}?type=cluster`),
        context.getters[GET_HTTP_CONFIG]
      ).then(response => {
        context.commit(SET_STUDY_RESULTS_3_MARKET_SEGMENT_STATE, {
          loadingState: LOADING_COMPLETED_SUCCESS,
          data: response.data,
          error: null,
        })

      }).catch(err => {
        console.error(err)
        context.commit(SET_STUDY_RESULTS_3_MARKET_SEGMENT_STATE, {
          loadingState: LOADING_COMPLETED_FAILURE,
          data: null,
          error: err,
        })
      })
    },
    [LOAD_STUDY_RESULTS_OVERALL_WORDS]: (context) => {
      context.commit(SET_STUDY_RESULTS_OVERALL_WORDS, {
        loadingState: LOADING_STARTED,
        data: context.state.studyResultsOverallWordsState.data,
        error: context.state.studyResultsOverallWordsState.error,
      })
      const studyId = context.getters[GET_CURRENT_ROUTE].params.id
      return http.get(
        context.getters[GET_BACKEND_URL](`words/${studyId}`),
        context.getters[GET_HTTP_CONFIG]
      ).then(response => {
        context.commit(SET_STUDY_RESULTS_OVERALL_WORDS, {
          loadingState: LOADING_COMPLETED_SUCCESS,
          data: response.data,
          error: null,
        })
      }).catch(err => {
        console.error(err)
        context.commit(SET_STUDY_RESULTS_OVERALL_WORDS, {
          loadingState: LOADING_COMPLETED_FAILURE,
          data: null,
          error: err,
        })
      })
    },
    [LOAD_STUDY_RESULTS_AGE_WORDS_STATE]: (context) => {
      context.commit(SET_STUDY_RESULTS_AGE_WORDS_STATE, {
        loadingState: LOADING_STARTED,
        data: context.state.studyResultsAgeWordsState.data,
        error: context.state.studyResultsAgeWordsState.error,
      })
      const studyId = context.getters[GET_CURRENT_ROUTE].params.id
      return http.get(
        context.getters[GET_BACKEND_URL](`seg-words/${studyId}?type=age`),
        context.getters[GET_HTTP_CONFIG]
      ).then(response => {
        context.commit(SET_STUDY_RESULTS_AGE_WORDS_STATE, {
          loadingState: LOADING_COMPLETED_SUCCESS,
          data: response.data,
          error: null,
        })
      }).catch(err => {
        console.error(err)
        context.commit(SET_STUDY_RESULTS_AGE_WORDS_STATE, {
          loadingState: LOADING_COMPLETED_FAILURE,
          data: null,
          error: err,
        })
      })
    },
    [LOAD_STUDY_RESULTS_GENDER_WORDS_STATE]: (context) => {
      context.commit(SET_STUDY_RESULTS_GENDER_WORDS_STATE, {
        loadingState: LOADING_STARTED,
        data: context.state.studyResultsGenderWordsState.data,
        error: context.state.studyResultsGenderWordsState.error,
      })
      const studyId = context.getters[GET_CURRENT_ROUTE].params.id
      return http.get(
        context.getters[GET_BACKEND_URL](`seg-words/${studyId}?type=gender`),
        context.getters[GET_HTTP_CONFIG]
      ).then(response => {
        context.commit(SET_STUDY_RESULTS_GENDER_WORDS_STATE, {
          loadingState: LOADING_COMPLETED_SUCCESS,
          data: response.data,
          error: null,
        })
      }).catch(err => {
        console.error(err)
        context.commit(SET_STUDY_RESULTS_GENDER_WORDS_STATE, {
          loadingState: LOADING_COMPLETED_FAILURE,
          data: null,
          error: err,
        })
      })
    },
    [LOAD_STUDY_RESULTS_PRELIM_WORDS_STATE]: (context) => {
      context.commit(SET_STUDY_RESULTS_PRELIM_WORDS_STATE, {
        loadingState: LOADING_STARTED,
        data: context.state.studyResultsPrelimWordsState.data,
        error: context.state.studyResultsPrelimWordsState.error,
      })
      const studyId = context.getters[GET_CURRENT_ROUTE].params.id
      return http.get(
        context.getters[GET_BACKEND_URL](`seg-words/${studyId}?type=prelim-answer`),
        context.getters[GET_HTTP_CONFIG]
      ).then(response => {
        context.commit(SET_STUDY_RESULTS_PRELIM_WORDS_STATE, {
          loadingState: LOADING_COMPLETED_SUCCESS,
          data: response.data,
          error: null,
        })
      }).catch(err => {
        console.error(err)
        context.commit(SET_STUDY_RESULTS_PRELIM_WORDS_STATE, {
          loadingState: LOADING_COMPLETED_FAILURE,
          data: null,
          error: err,
        })
      })
    },
    [LOAD_STUDY_RESULTS_2_MARKET_SEGMENT_WORDS_STATE]: (context) => {
      context.commit(SET_STUDY_RESULTS_2_MARKET_SEGMENT_WORDS_STATE, {
        loadingState: LOADING_STARTED,
        data: context.state.studyResults2MarketSegmentsWordsState.data,
        error: context.state.studyResults2MarketSegmentsWordsState.error,
      })
      const studyId = context.getters[GET_CURRENT_ROUTE].params.id
      return http.get(
        context.getters[GET_BACKEND_URL](`seg-words/${studyId}?type=cluster`),
        context.getters[GET_HTTP_CONFIG]
      ).then(response => {
        context.commit(SET_STUDY_RESULTS_2_MARKET_SEGMENT_WORDS_STATE, {
          loadingState: LOADING_COMPLETED_SUCCESS,
          data: response.data,
          error: null,
        })
      }).catch(err => {
        console.error(err)
        context.commit(SET_STUDY_RESULTS_2_MARKET_SEGMENT_WORDS_STATE, {
          loadingState: LOADING_COMPLETED_FAILURE,
          data: null,
          error: err,
        })
      })
    },
    [LOAD_STUDY_RESULTS_3_MARKET_SEGMENT_WORDS_STATE]: (context) => {
      context.commit(SET_STUDY_RESULTS_3_MARKET_SEGMENT_WORDS_STATE, {
        loadingState: LOADING_STARTED,
        data: context.state.studyResults3MarketSegmentsWordsState.data,
        error: context.state.studyResults3MarketSegmentsWordsState.error,
      })
      const studyId = context.getters[GET_CURRENT_ROUTE].params.id
      return http.get(
        context.getters[GET_BACKEND_URL](`seg-words/${studyId}?type=cluster2`),
        context.getters[GET_HTTP_CONFIG]
      ).then(response => {
        context.commit(SET_STUDY_RESULTS_3_MARKET_SEGMENT_WORDS_STATE, {
          loadingState: LOADING_COMPLETED_SUCCESS,
          data: response.data,
          error: null,
        })
      }).catch(err => {
        console.error(err)
        context.commit(SET_STUDY_RESULTS_3_MARKET_SEGMENT_WORDS_STATE, {
          loadingState: LOADING_COMPLETED_FAILURE,
          data: null,
          error: err,
        })
      })
    },
    [LOAD_ALL_STUDY_RESULTS_DATA]: (context) => {
      context.commit(SET_ALL_SECONDARY_STUDY_RESULTS_STATE, {
        loadingState: LOADING_STARTED,
        data: context.state.allSecondaryStudyResultsState.data,
        error: context.state.allSecondaryStudyResultsState.error,
      })
      return Promise.all([
        context.dispatch(LOAD_STUDY_RESULTS),
        context.dispatch(LOAD_STUDY_RESULTS_OVERALL_WORDS),
      ]).then(() => {
        return Promise.all([
          context.dispatch(LOAD_STUDY_RESULTS_AGE),
          context.dispatch(LOAD_STUDY_RESULTS_GENDER),
          context.dispatch(LOAD_STUDY_RESULTS_PRELIM),
          context.dispatch(LOAD_STUDY_RESULTS_2_MARKET_SEGMENT),
          context.dispatch(LOAD_STUDY_RESULTS_3_MARKET_SEGMENT),
          context.dispatch(LOAD_STUDY_RESULTS_AGE_WORDS_STATE),
          context.dispatch(LOAD_STUDY_RESULTS_GENDER_WORDS_STATE),
          context.dispatch(LOAD_STUDY_RESULTS_PRELIM_WORDS_STATE),
          context.dispatch(LOAD_STUDY_RESULTS_2_MARKET_SEGMENT_WORDS_STATE),
          context.dispatch(LOAD_STUDY_RESULTS_3_MARKET_SEGMENT_WORDS_STATE),
        ])
      }).then(() => {
        context.commit(SET_ALL_SECONDARY_STUDY_RESULTS_STATE, {
          loadingState: LOADING_COMPLETED_SUCCESS,
          data: null,
          error: null,
        })

      }).catch(err => {
        console.error(err)
        context.commit(SET_STUDY_RESULTS_3_MARKET_SEGMENT_STATE, {
          loadingState: LOADING_COMPLETED_FAILURE,
          data: null,
          error: err,
        })
      })
    },
    [A_STORE_RESULTS_MODULE_PER_ROUTE_ACTIONS]: (context, toRoute) => {
      const actions = []
      if (toRoute.name === R_NAME_RESULTS || toRoute.name === R_NAME_MANAGE_PARTICIPANTS || toRoute.name === R_NAME_PURCHASE) {
        actions.push(context.dispatch(LOAD_ALL_STUDY_RESULTS_DATA))
        actions.push(context.dispatch(GET_STUDY, context.getters[GET_CURRENT_ROUTE].params.id))
      }
      return Promise.all(actions)
    },
  }
}

export default module
export const studyResultsModule = module
